/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CartItem } from './cart-item';
import { CustomProductDto } from './custom-product-dto';
import { ManualDiscountDto } from './manual-discount-dto';
import { ManualShippingDto } from './manual-shipping-dto';
/**
 * 
 * @export
 * @interface GuestCheckoutDto
 */
export interface GuestCheckoutDto {
  _id?: string;
    /**
     * 
     * @type {Array<CartItem>}
     * @memberof GuestCheckoutDto
     */
    items?: Array<CartItem>;
    /**
     * 
     * @type {string}
     * @memberof GuestCheckoutDto
     */
    notes?: string;
    /**
     * 
     * @type {ManualDiscountDto}
     * @memberof GuestCheckoutDto
     */
    manualDiscount: ManualDiscountDto;
    /**
     * 
     * @type {string}
     * @memberof GuestCheckoutDto
     */
    discountId: string;
    /**
     * 
     * @type {ManualShippingDto}
     * @memberof GuestCheckoutDto
     */
    manualShipping: ManualShippingDto;
    /**
     * 
     * @type {Date}
     * @memberof GuestCheckoutDto
     */
    paymentDueDate: Date;
    /**
     * 
     * @type {boolean}
     * @memberof GuestCheckoutDto
     */
    chargeTax: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof GuestCheckoutDto
     */
    orderRemindingDates: Array<string>;
    /**
     * 
     * @type {Array<CustomProductDto>}
     * @memberof GuestCheckoutDto
     */
    customProducts?: Array<CustomProductDto>;
    /**
     * 
     * @type {string}
     * @memberof GuestCheckoutDto
     */
    paymentMethod: GuestCheckoutDtoPaymentMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof GuestCheckoutDto
     */
    orderStatus: GuestCheckoutDtoOrderStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GuestCheckoutDto
     */
    paymentStatus?: GuestCheckoutDtoPaymentStatusEnum;
    /**
     * If true, skips email verification (admin creating order on behalf of user)
     * @type {boolean}
     * @memberof GuestCheckoutDto
     */
    isManualOrder?: boolean;
    /**
     * Stripe PaymentMethod ID collected from the storefront card step. When provided, the order is charged immediately instead of sending an invoice.
     * @type {string}
     * @memberof GuestCheckoutDto
     */
    paymentMethodId?: string;
    /**
     * Send order confirmation email to the customer. Defaults to true.
     * @type {boolean}
     * @memberof GuestCheckoutDto
     */
    sendConfirmationEmail?: boolean;
    /**
     * Send invoice email to the customer when a Stripe invoice is created. Defaults to true.
     * @type {boolean}
     * @memberof GuestCheckoutDto
     */
    sendInvoiceEmail?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GuestCheckoutDto
     */
    deliveryMethod?: GuestCheckoutDtoDeliveryMethodEnum;
    /**
     * User address ID for custom delivery orders
     * @type {string}
     * @memberof GuestCheckoutDto
     */
    userAddressId?: string;
    /**
     * Inline delivery address for custom delivery — used when the user has no saved address yet (e.g. guest checkout price preview)
     * @type {any}
     * @memberof GuestCheckoutDto
     */
    deliveryAddress?: any;
    /**
     * 
     * @type {string}
     * @memberof GuestCheckoutDto
     */
    firstname: string;
    /**
     * 
     * @type {string}
     * @memberof GuestCheckoutDto
     */
    lastname: string;
    /**
     * 
     * @type {string}
     * @memberof GuestCheckoutDto
     */
    email: string;
}

/**
    * @export
    * @enum {string}
    */
export enum GuestCheckoutDtoPaymentMethodEnum {
    Cash = 'Cash',
    Credit = 'Credit',
    Card = 'Card'
}
/**
    * @export
    * @enum {string}
    */
export enum GuestCheckoutDtoOrderStatusEnum {
    Pending = 'Pending',
    PickingPacking = 'Picking & Packing',
    ReadyForPickup = 'Ready for Pickup',
    PickedUp = 'Picked Up',
    OutForDelivery = 'Out for Delivery',
    Delivered = 'Delivered',
    OnHold = 'On Hold',
    Cancelled = 'Cancelled'
}
/**
    * @export
    * @enum {string}
    */
export enum GuestCheckoutDtoPaymentStatusEnum {
    Paid = 'Paid',
    Unpaid = 'Unpaid'
}
/**
    * @export
    * @enum {string}
    */
export enum GuestCheckoutDtoDeliveryMethodEnum {
    Shippo = 'shippo',
    Custom = 'custom',
    Pickup = 'pickup'
}

